<div class="action-bar">
    <button *ngFor="let action of actionsToShow"
            class="action-btn"
            (click)="handleAction(action)"
            [title]="action.tooltip">
        <mat-icon> <mat-icon>{{ !action.isActive ? action.offIcon : action.onIcon }}</mat-icon> </mat-icon>
    </button>
</div>